<template>
  <v-layout justify-center>
    <v-snackbar top v-model="snackBarDisplayed">The username for {{user.firstName}} {{user.lastName}} has been changed.</v-snackbar>
    <v-flex>
      <v-dialog v-model="value" persistent max-width="350px">
        <v-form ref="form">
          <v-card @keyup.enter="updateClicked">
            <v-card-title class="text-xs-center">
              <v-flex class="headline">New Username for<br>{{user.firstName}} {{user.lastName}}</v-flex>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-layout>
                  <v-flex>
                    <v-text-field label="Old Username" :value="user.username" disabled></v-text-field>
                    <v-text-field label="New Username" v-model.trim="username" :rules="[required]" :disabled="updatingUsername"></v-text-field>
                    <v-alert dismissible outlined v-model="errorChangingUsername" type="error">Unable to change the username at this time.</v-alert>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!confirming">
              <v-spacer></v-spacer>
              <v-btn @click.native="updateClicked()">Update</v-btn>
              <v-btn @click.native="cancelClicked()">Cancel</v-btn>
            </v-card-actions>
            <v-card-actions v-if="confirming">
              <v-btn @click.native="confirmClicked()" :loading="updatingUsername" :disabled="updatingUsername">Confirm</v-btn>
              <v-btn @click.native="cancelClicked()" :disabled="updatingUsername">Cancel</v-btn>
              <v-spacer ></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
//
// See Note 3 in 'doc/Notes.txt' for information pertaining to this component.
//
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import validators from '@/utility/validators';

@Component
export default class EditUsernameDialog extends Vue {
  @Prop(Function) changeUsername;
  @Prop(Object) user;
  @Prop(Boolean) value;

  confirming = false;
  updatingUsername = false;
  errorChangingUsername = false;
  snackBarDisplayed = false;
  username = this.defaultUsername();
  required = validators.required;

  /*
   * It is common for the Username to match the email. So
   * default to the email if the Username is not already set
   * to that value.
   */
  defaultUsername() {
    return (this.user.username === this.user.email) ? '' : this.user.email;
  }

  @Watch('value')
  onDialogChanged(dialogOpened) {
    if (dialogOpened) {
      this.username = this.defaultUsername();
      this.confirming = false;

      // The form may not exist the very first time we open the dialog but that
      // is OK because it will not initially be invalid anyway. But we want to
      // make sure there are no invalid fields each time we re-open it.
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  }

  updateClicked() {
    if (this.$refs.form.validate()) {
      this.confirming = true;
      this.errorChangingUsername = false;
    }
  }

  confirmClicked() {
    this.updatingUsername = true;
    this.changeUsername(this.user, this.username).then(() => {
      this.user.username = this.username;
      this.updatingUsername = false;
      this.snackBarDisplayed = true;
      this.closeDialog();
    }).catch((error) => {
      console.error('Error updating username:', error.message);
      this.confirming = false;
      this.updatingUsername = false;
      this.errorChangingUsername = true;
    });
  }

  cancelClicked() {
    this.closeDialog();
  }

  closeDialog() {
    // This changes the 'value' Prop in the parent component to false and
    // since it is bound to the dialog's activator, will close the dialog.
    this.$emit('input', false);
  }
}
</script>
